import React from "react";

const ExitIcon = ({
  width = "28",
  height = "29",
  active = false,
  activeColor = "#1D5AB9",
  inActiveColor = "#969998",
  color = active ? activeColor : inActiveColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.62055 4.08518C0.459142 4.12259 0.368044 4.28121 0.417077 4.43947L0.694281 5.33421C0.743314 5.49247 0.913909 5.59045 1.07532 5.55304L1.64652 5.42067V12.4433C1.64652 12.609 1.78083 12.7433 1.94652 12.7433H3.54287C3.70856 12.7433 3.84287 12.609 3.84287 12.4433V4.91169L18.7019 1.46825C18.8633 1.43085 18.9544 1.27223 18.9054 1.11396L18.6282 0.219228C18.5792 0.0609641 18.4086 -0.0370117 18.2472 0.000392937L3.84287 3.33844V3.16564C3.84287 2.99995 3.70856 2.86564 3.54287 2.86564H1.94652C1.78083 2.86564 1.64652 2.99995 1.64652 3.16564V3.84743L0.62055 4.08518ZM3.05116 4.38532C3.05116 4.55318 2.89382 4.68925 2.69974 4.68925C2.50566 4.68925 2.34833 4.55318 2.34833 4.38532C2.34833 4.21747 2.50566 4.08139 2.69974 4.08139C2.89382 4.08139 3.05116 4.21747 3.05116 4.38532ZM4.46898 3.43409L5.24821 3.24545L4.97318 4.42448L4.19396 4.61312L4.46898 3.43409ZM6.82983 2.86551L6.0506 3.05415L5.77558 4.23318L6.55481 4.04454L6.82983 2.86551ZM7.63223 2.67421L8.41146 2.48556L8.13643 3.6646L7.35721 3.85324L7.63223 2.67421ZM9.99248 2.10575L9.21325 2.2944L8.93823 3.47343L9.71746 3.28478L9.99248 2.10575ZM10.7943 1.91446L11.5735 1.72581L11.2985 2.90484L10.5193 3.09349L10.7943 1.91446ZM13.1551 1.34587L12.3759 1.53452L12.1009 2.71355L12.8801 2.5249L13.1551 1.34587ZM13.7813 1.23071L14.5605 1.04206L14.2855 2.22109L13.5063 2.40974L13.7813 1.23071ZM16.1428 0.737991L15.3635 0.926636L15.0885 2.10567L15.8678 1.91702L16.1428 0.737991ZM16.9446 0.54676L17.7238 0.358115L17.4488 1.53715L16.6695 1.72579L16.9446 0.54676Z"
        fill={color}
      />
      <path
        d="M15.0796 8.33073C15.3247 8.14522 15.3247 7.84397 15.0796 7.65846L11.942 5.28402C11.6968 5.09852 11.2987 5.09852 11.0536 5.28402C10.8085 5.46953 10.8085 5.77078 11.0536 5.95629L13.1225 7.52045H7.10605C6.75894 7.52045 6.47852 7.73267 6.47852 7.99534C6.47852 8.25801 6.75894 8.47023 7.10605 8.47023H13.1205L11.0556 10.0344C10.8104 10.2199 10.8104 10.5211 11.0556 10.7067C11.3007 10.8922 11.6988 10.8922 11.9439 10.7067L15.0816 8.33221L15.0796 8.33073Z"
        fill={color}
      />
    </svg>
  );
};

export default ExitIcon;
